<template>
  <component
    :is="applicationCard.component"
    class="w-90 ms-2 mb-1"
    :class="applicationCard.class"
    v-if="shouldShowApplicationNavbarCard === true"
  >
    <div class="hover-side-nav-link-bg d-flex align-items-center" v-if="isFlexRetailer === false">
      <div class="icon-container">
        <i :class="salesLink.icon"></i>
      </div>
      <span class="name-of-link">
        {{ salesLink.text }}
      </span>
    </div>
    <div class="d-flex flex-column align-items-center" :class="{ 'mt-2': isFlexRetailer === false }">
      <div class="d-flex w-100 sales-line-anchor">
        <base-button
          :item-class="applicationButtonClass"
          data-testid="retailer-new-application"
          :aria-haspopup="menuAriaHasPopup"
          :aria-expanded="menuAriaExpanded"
          :disabled="isHeadlineSalesLineClosed"
          @click="startApplication"
        >
          <div class="d-flex align-items-center">
            <i class="mdi mdi-cart me-2" v-if="isFlexRetailer === true" />
            {{ applicationCreateLabel }}
          </div>
          <div class="d-flex pe-0 chevron-icon">
            <i class="mdi mdi-chevron-right text-white mdi-20px" />
          </div>
        </base-button>
        <sales-line-menu
          v-if="isShowingSalesLineMenu === true"
          class="sales-line-menu-popover"
          :sales-lines="salesLines"
          @select="startSalesLineApplication"
        />
      </div>
      <small v-if="isHeadlineSalesLineClosed === true" class="w-100 mt-1 text-muted">
        {{ $t('views.layouts.sales_channel_closed') }}
      </small>
      <template v-if="hasSalesLineMenu === false">
        <div
          v-for="salesLine in additionalSalesLines"
          :key="salesLine.routeName"
          class="d-flex flex-column w-100 mt-2"
        >
          <base-button
            item-class="btn-md d-flex justify-content-between align-items-center w-100 fw-normal btn-outline-secondary text-secondary"
            :data-testid="salesLine.testId"
            :disabled="salesLine.isOpen === false"
            @click="clickToTarfinApplicationCreate(salesLine.routeName)"
          >
            <div class="d-flex align-items-center">
              <i class="me-1" :class="salesLine.icon" />
              {{ $t(salesLine.labelKey) }}
            </div>
            <div class="d-flex pe-0 chevron-icon">
              <i class="mdi mdi-chevron-right mdi-20px" />
            </div>
          </base-button>
          <small v-if="salesLine.isOpen === false" class="mt-1 text-muted">
            {{ $t('views.layouts.sales_channel_closed') }}
          </small>
        </div>
      </template>
    </div>
  </component>
  <template v-else>
    <ul class="side-nav side-nav-light mb-0">
      <li class="side-nav-item fixed-button">
        <div v-if="hasSalesLineMenu === true" class="sales-line-anchor">
          <button
            type="button"
            class="btn sale-specific-button"
            :class="{ 'sale-specific-button-flex': isFlexRetailer === true }"
            data-testid="retailer-new-application"
            :aria-label="applicationCreateLabel"
            aria-haspopup="menu"
            :aria-expanded="isShowingSalesLineMenu"
            @click="startApplication"
          >
            <i class="mdi mdi-cart sale-specific-icons" />
            <i class="mdi mdi-chevron-right sale-specific-icons sale-specific-chevron" />
          </button>
          <sales-line-menu
            v-if="isShowingSalesLineMenu === true"
            class="sales-line-menu-popover"
            :sales-lines="salesLines"
            @select="startSalesLineApplication"
          />
        </div>
        <div v-else class="dropdown">
          <button
            class="btn sale-specific-button"
            :class="{ 'sale-specific-button-flex': isFlexRetailer === true }"
            data-bs-toggle="dropdown"
            data-bs-boundary="window"
            aria-expanded="false"
          >
            <i class="mdi mdi-cart sale-specific-icons" />
            <i class="mdi mdi-chevron-right sale-specific-icons sale-specific-chevron" />
          </button>
          <ul
            class="dropdown-menu fiba-channel-button-wrapper"
            :class="{ 'fiba-channel-button-wrapper-flex': isFlexRetailer === true }"
          >
            <div class="d-flex flex-column">
              <div class="d-flex justify-content-start align-items-center">
                <div class="d-flex align-items-center">
                  <i
                    class="mdi mdi-cart me-0 ms-2"
                    :class="{ 'tarfin-application-icon': isMouseOverTarfinApplicationButton === true }"
                  ></i>
                </div>
                <div
                  class="d-flex me-auto"
                  :class="isHeadlineSalesLineClosed === true ? 'flex-column' : 'align-items-center'"
                >
                  <base-button
                    item-class="toggle-channel-button-2 btn-outline-secondary justify-content-between align-items-center d-flex w-100 text-secondary"
                    data-testid="retailer-new-application"
                    :disabled="isHeadlineSalesLineClosed"
                    @click="clickToTarfinApplicationCreate(salesLink.name)"
                    @mouseover="hoverTarfinApplicationButton"
                    @mouseleave="notHoverTarfinApplicationButton"
                  >
                    <span class="showing-button-text-2">{{ applicationCreateLabel }}</span></base-button
                  >
                  <small v-if="isHeadlineSalesLineClosed === true" class="px-2 pb-1 text-muted">
                    {{ $t('views.layouts.sales_channel_closed') }}
                  </small>
                </div>
              </div>
              <div
                v-for="salesLine in additionalSalesLines"
                :key="salesLine.routeName"
                class="d-flex justify-content-start align-items-center"
              >
                <div class="d-flex align-items-center">
                  <i class="me-0 ms-2" :class="salesLine.icon"></i>
                </div>
                <div
                  class="d-flex me-auto"
                  :class="salesLine.isOpen === false ? 'flex-column' : 'align-items-center'"
                >
                  <base-button
                    item-class="toggle-channel-button-2 btn-outline-secondary justify-content-between align-items-center d-flex w-100 text-secondary"
                    :data-testid="salesLine.testId"
                    :disabled="salesLine.isOpen === false"
                    @click="clickToTarfinApplicationCreate(salesLine.routeName)"
                  >
                    <span class="showing-button-text-2">{{ $t(salesLine.labelKey) }}</span></base-button
                  >
                  <small v-if="salesLine.isOpen === false" class="px-2 pb-1 text-muted">
                    {{ $t('views.layouts.sales_channel_closed') }}
                  </small>
                </div>
              </div>
            </div>
          </ul>
        </div>
      </li>
    </ul>
  </template>
</template>

<script setup>
import { computed, onBeforeMount, onBeforeUnmount, onMounted, ref, watch } from 'vue'
import { useRouter } from 'vue-router'
import { storeToRefs } from 'pinia'
import { event } from 'vue-gtag'
import { useI18n } from 'vue-i18n'
import { useSideMenuStore } from '@/stores/helpers/sideMenu.js'
import Retailer from '@/utilities/retailerHelper.js'
import BaseButton from '@/components/BaseButton.vue'
import BaseCard from '@/components/BaseCard.vue'
import SalesLineMenu from '@/components/retailer/navbar/SalesLineMenu.vue'

// #region - i18n set
const { t } = useI18n()
// endregion

// #region - Vuex state
const sideMenuStore = useSideMenuStore()
const { sidebarActive } = storeToRefs(sideMenuStore)
// endregion

// #region - references
const salesLink = ref({
  text: t('views.layouts.sale'),
  icon: 'mdi mdi-cart',
  name: 'retailer.dashboard'
})

const isMouseOverTarfinApplicationButton = ref(false)
const shouldShowApplicationNavbarCard = ref(true)
const ignoreFirstShowValue = ref(true)
const isShowingSalesLineMenu = ref(false)
// endregion

// #region - observer for document body watch
let observer = null
// endregion

// #region - router set
const router = useRouter()
// endregion

// #region - which channel should be shown
// endregion

// #region - lifecycle hooks
onBeforeMount(() => {
  salesLink.value = {
    text: t('views.layouts.sale'),
    icon: 'mdi mdi-cart',
    name: Retailer.salesApplicationRouteName()
  }
})
// endregion

// #region - onMounted lifecycle hook
onMounted(() => {
  updateScrollableBodyMode()

  observer = new MutationObserver(() => {
    updateScrollableBodyMode()
  })

  observer.observe(document.body, {
    attributes: true,
    attributeFilter: ['data-leftbar-compact-mode']
  })

  window.addEventListener('click', closeSalesLineMenu)
  window.addEventListener('keydown', closeSalesLineMenuOnEscape)
})
// endregion

// #region - onMounted lifecycle hook
onBeforeUnmount(() => {
  if (observer) {
    observer.disconnect()
  }

  window.removeEventListener('click', closeSalesLineMenu)
  window.removeEventListener('keydown', closeSalesLineMenuOnEscape)
})
// endregion

// #region - computed properties
const isSidebarActive = computed(() => {
  return sidebarActive.value
})

const isFlexRetailer = computed(() => Retailer.isFlex())

// Flex drops the grey card and the "Yeni Satış" heading it carried, so its button block sits
// straight on the sidebar in a wrapper that only keeps the card's spacing.
const applicationCard = computed(() =>
  isFlexRetailer.value === true
    ? { component: 'div', class: 'flex-make-sell-wrapper' }
    : { component: BaseCard, class: 'gray-make-sell-card-background' }
)

const applicationCreateLabel = computed(() => {
  return isFlexRetailer.value === true
    ? t('views.layouts.tarfin_flex_application_create')
    : t('views.layouts.tarfin_application_create')
})

const applicationButtonClass = computed(() => {
  const base = 'btn-md d-flex justify-content-between align-items-center w-100 fw-normal'
  return isFlexRetailer.value === true
    ? `${base} flex-application-button`
    : `${base} btn-primary tarfin-application-button`
})

// A line whose sales channel is closed stays listed but cannot be started, so every entry carries
// whether it is open.
const withOpenState = salesLines =>
  salesLines.map(salesLine => ({ ...salesLine, isOpen: Retailer.isSalesChannelOpen(salesLine.salesChannel) }))

// Every sales line the menu lists, in the order the design has them.
const salesLines = computed(() => withOpenState(Retailer.salesLines()))

// One entry per further sales line the retailer holds the channel for, alongside the standard
// application button their retailer type already opens. Only reached by the retailers who get no
// menu: they keep the button-per-line layout they have today.
const additionalSalesLines = computed(() => withOpenState(Retailer.additionalSalesLines()))

// Only a retailer selling both second-hand cars and tractors picks a line from a menu before
// starting an application; every other retailer keeps the entry points they have today.
const hasSalesLineMenu = computed(() => Retailer.hasCarAndTractorSalesChannels())

// The headline button routes straight to its line unless it opens the menu; then the menu marks
// the closed lines itself and the button stays usable.
const isHeadlineSalesLineClosed = computed(
  () => hasSalesLineMenu.value === false && Retailer.isSalesApplicationRouteOpen(salesLink.value.name) === false
)

// Left off the button that carries no menu: it navigates rather than opening anything.
const menuAriaHasPopup = computed(() => (hasSalesLineMenu.value === true ? 'menu' : undefined))

const menuAriaExpanded = computed(() => (hasSalesLineMenu.value === true ? isShowingSalesLineMenu.value : undefined))
// endregion

// #region - method definitions
const updateScrollableBodyMode = () => {
  shouldShowApplicationNavbarCard.value = document.body.getAttribute('data-leftbar-compact-mode') === 'scrollable'
}

const clickToTarfinApplicationCreate = name => {
  sideMenuStore.setActiveMenuIndex(null)

  event('application_menu_click')
  router.push({
    name: name
  })
}

/**
 * The button toggles the menu wherever there is one to toggle and routes for everyone else.
 *
 * Closing on a second click is the button's own job rather than the document listener's: that one
 * ignores clicks landing inside the anchor, and the button sits inside it.
 */
const startApplication = () => {
  if (hasSalesLineMenu.value === true) {
    isShowingSalesLineMenu.value = isShowingSalesLineMenu.value === false

    return
  }

  clickToTarfinApplicationCreate(salesLink.value.name)
}

const startSalesLineApplication = salesLine => {
  isShowingSalesLineMenu.value = false

  clickToTarfinApplicationCreate(salesLine.routeName)
}

// Anything outside the anchor closes the menu. Asked of the class rather than of a template ref so
// that the one handler serves both layouts, only one of which is mounted at a time.
const closeSalesLineMenu = event => {
  if (event.target.closest('.sales-line-anchor') === null) {
    isShowingSalesLineMenu.value = false
  }
}

// Escape closes the menu wherever the focus sits, the one keyboard affordance the sidebar's
// Bootstrap dropdown used to carry.
const closeSalesLineMenuOnEscape = event => {
  if (event.key === 'Escape') {
    isShowingSalesLineMenu.value = false
  }
}

const hoverTarfinApplicationButton = () => {
  isMouseOverTarfinApplicationButton.value = true
}

const notHoverTarfinApplicationButton = () => {
  isMouseOverTarfinApplicationButton.value = false
}
// endregion

// #region - watch part
watch(
  () => isSidebarActive.value,
  (newVal, _) => {
    if (ignoreFirstShowValue.value === true) {
      ignoreFirstShowValue.value = false
      return
    }
    shouldShowApplicationNavbarCard.value = newVal
  }
)

// The two layouts anchor the menu to different buttons, so an open menu is dropped as the sidebar
// changes shape rather than left hanging next to a button that is no longer on screen.
watch(
  () => shouldShowApplicationNavbarCard.value,
  () => {
    isShowingSalesLineMenu.value = false
  }
)
// endregion
</script>

<style>
.gray-make-sell-card-background {
  > .card-body {
    padding: 1rem;
  }
}
</style>

<style scoped>
.gray-make-sell-card-background {
  background-color: #f0f0f1;
  margin-top: 0.5rem;

  > .card-body {
    padding: 1rem;
  }
}

.flex-make-sell-wrapper {
  margin-top: 0.5rem;
  padding: 1rem;
}

.w-90 {
  width: 90%;
}

.fixed-button {
  height: 38px;
}

.fixed-button > .dropdown,
.fixed-button > .sales-line-anchor {
  display: flex;
  justify-content: center;
  width: 100%;
}

.icon-container {
  position: relative;
  display: inline-block;
}

.name-of-link {
  margin-left: 0.889rem;
  vertical-align: middle;
}

.sales-line-anchor {
  position: relative;
}

.fiba-channel-button-wrapper {
  background-color: var(--white);
  border-style: none;
  border-width: 0;
  transform: translate(75px, 5px) !important;
  box-shadow: 1px 1px 35px rgba(154, 161, 171, 0.15) !important;
}

.toggle-channel-button-2 {
  background-color: var(--white);
  height: 40px;
  font-weight: 400;
  font-size: 13.22px;
  border-style: none;
  border: none;
  &:hover {
    background-color: var(--white);
    .showing-button-text-2 {
      color: var(--primary);
    }
  }
}

.tarfin-application-icon {
  color: var(--primary);
}

.fiba-channel-button-wrapper-flex .toggle-channel-button-2:hover .showing-button-text-2,
.fiba-channel-button-wrapper-flex .tarfin-application-icon {
  color: var(--violet-700);
}

/* Top aligned with the button and clear of it by 4px, as the design has it. The menu is wider than
   the room left in the sidebar and is meant to spill over the page next to it. */
.sales-line-menu-popover {
  left: calc(100% + 4px);
  position: absolute;
  top: 0;
  z-index: 10;
}

.tarfin-application-button:hover {
  background-color: var(--primary-hover);
  color: white !important;
}

.flex-application-button {
  background-color: var(--violet-700);
  color: white;
}

.flex-application-button:hover {
  background-color: var(--violet-hover);
  color: white !important;
}

.sale-specific-button {
  align-items: center;
  background-color: var(--primary);
  border: none;
  border-radius: 25px;
  color: var(--white);
  display: flex;
  flex: 0 0 auto;
  height: 38px;
  justify-content: center;
  margin: 0 auto;
  padding: 0;
  width: 54px;
}

.sale-specific-button:hover,
.sale-specific-button:focus,
.sale-specific-button:active {
  background-color: var(--primary-hover);
  color: var(--white);
}

.sale-specific-button-flex {
  background-color: var(--violet-700);
}

.sale-specific-button-flex:hover,
.sale-specific-button-flex:focus,
.sale-specific-button-flex:active {
  background-color: var(--violet-hover);
}

.sale-specific-icons {
  font-size: 1.125rem;
}

.sale-specific-chevron {
  font-size: 1rem;
}
</style>
